import PagedFilter from 'core/application/commons/pagedFilter'

import { Button, Icon } from 'common/components'
import { formatYear, parseZoneFormat } from 'common/dateFormatters'

export const employeeHSAColumns = (
  translate: (key: string) => string,
  filter: PagedFilter,
  handleHSAModalOpen: any,
  hasMultiplePlanPeriod: boolean,
): any[] => {
  return [
    {
      title: translate('admin-dashboard.manage-people.view-employee.benefit-history.columns.hsa-plan-year'),
      dataIndex: 'year',
      key: 'year',
      sorter: false,
      render: (text: string, record: any) =>
        hasMultiplePlanPeriod ? (
          <span>
            {parseZoneFormat(record.startDate)} - {parseZoneFormat(record.endDate)}
          </span>
        ) : (
          <span>{formatYear(record.endDate)}</span>
        ),
    },
    {
      title: translate('admin-dashboard.manage-people.view-employee.benefit-history.columns.hsa-contributing'),
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          {hasMultiplePlanPeriod
            ? `${record.yearStartDate}; ${record.yearMatchStartDate} | ${record.yearEndDate}; ${record.yearMatchEndDate}`
            : record.yearMatchEndDate}
          <Button className="color-green-6" type="link" onClick={() => handleHSAModalOpen(record)}>
            <Icon type="fa fa-pencil-alt" fontAwesome />
          </Button>
        </span>
      ),
    },
  ]
}
